import React, { createContext, useState, useEffect, useContext } from "react";
import { EDUCATION_LINK, POPUP_TYPES, SKILLS_LINK, SUMMARY_LINK, WORKHISTORY_LINK } from "../constants/constants";
import { removeBodyScroll } from "../helper";

const PopupContext = createContext({});

export const PopupProvider = ({ children }) => {

    const defaultContent = {
        msgbox: {
            heading: 'Message',
            content: 'Successfully completed',
            confirmButtonText: 'ok'
        },
        waitingbox: {
            heading: 'Message',
            content: 'Please Wait...',
            // confirmButtonText: 'ok'
        },
        confirmbox: {
            heading: 'Message',
            content: 'Please confirm your action',
            confirmButtonText: 'ok',
            cancelButtonText: 'cancel'
        },
        sharebox: {
            heading: 'Share',
            content: 'Please share your link',
            copyButtonText: 'Copy Link',
            openLinkText: 'Open Link'
        },
        downloadbox: {
            heading: 'Download',
            content: 'Download Resume',
            copyButtonText: 'Continue',
            openLinkText: 'Cancel'
        },
        duplicatebox: {
            heading: 'Duplicate',
            content: 'Choose a Name',
            saveButtonText: 'Save',
            cancelButtonText: 'Cancel'
        },
        renamebox: {
            heading: 'Rename',
            content: 'Enter a Name',
            saveButtonText: 'Save',
            cancelButtonText: 'Cancel'
        },
        genericbox:{
            content:'',
        },
        alertbox: {
            heading: 'Heads up!',
            content: '',
            confirmButtonText: 'ok'
        },
        aientitytitlebox: {
          type: 'aientitytitlebox',
          content: {
            content: ''
          }
        }
    }
    const types = { msgbox: 'msgbox', confirmbox: 'confirmbox', sharebox: 'sharebox', downloadbox: 'downloadbox', duplicatebox: 'duplicatebox', renamebox: 'renamebox', alertbox: 'alertbox', aientitytitlebox: 'aientitytitlebox'}

    const [showConfirmBox, setshowConfirmBox] = useState();
    const [showMsgBox, setshowMsgBox] = useState();
    const [showShareBox, setshowShareBox] = useState();
    const [showDownloadBox, setshowDownloadBox] = useState();
    const [showRearrangeBox, setshowRearrangeBox] = useState();
    const [showDuplicateBox, setShowDuplicateBox] = useState();
    const [showRenameBox, setShowRenameBox] = useState();
    const [showAlertBox, setShowAlertBox] = useState();
    const [showAIEntityTitleBox, setShowAIEntityTitleBox] = useState();
    const [showWaitingBox, setShowWaitingBox] = useState();
    const [showAskForReviewBox, setShowAskForReviewBox] = useState();
    const [popupType, setPopupType] = useState();
    const [boxContent, setBoxContent] = useState();
    const [rightCallback, setrightCallback] = useState();
    const [leftCallback, setleftCallback] = useState();
    const [data, setData] = useState();
    const [boxes, setBoxes] = useState({});
    const [activeid, setActiveId] = useState();
    const [waiting, setWaiting] = useState(false)
    //For components to show popup
    const show = (id,leftCallback=null,rightCallback=null,data=null) => {
        const box = boxes[id] ?? POPUP_TYPES[id];
        //const bc = {...data.content} ?? {...box.content};
        setBoxContent({ ...defaultContent[box.type], ...box.content })
        setPopupType(box.type)
        setActiveId(id);
        rightCallback && setrightCallback({ e: rightCallback })
        leftCallback && setleftCallback({ e: leftCallback })
        data && setData(data)
        if (box.type == 'msgbox') setshowMsgBox(true)
        else if (box.type == 'confirmbox') setshowConfirmBox(true)
        else if (box.type == 'sharebox') setshowShareBox(true)
        else if (box.type == 'downloadbox') setshowDownloadBox(true)
        else if (box.type == 'rearrangebox') setshowRearrangeBox(true)
        else if (box.type == 'duplicatebox') setShowDuplicateBox(true)
        else if (box.type == 'renamebox') setShowRenameBox(true)
        else if (box.type == 'alertbox') setShowAlertBox(true)
        else if (box.type == 'aientitytitlebox') setShowAIEntityTitleBox(true)
        else if (box.type == 'waitingbox') setShowWaitingBox(true)
        else if (box.type == 'askforreview') setShowAskForReviewBox(true)
    }
    //For popup components
    const close = (type = '', callback = null) => {
        type.length && setPopupType(type)
        if (popupType == 'msgbox') setshowMsgBox(false)
        else if (popupType == 'confirmbox') setshowConfirmBox(false)
        else if (popupType == 'sharebox') setshowShareBox(false)
        else if (popupType == 'downloadbox') setshowDownloadBox(false)
        else if (popupType == 'rearrangebox') setshowRearrangeBox(false)
        else if (popupType == 'duplicatebox') setShowDuplicateBox(false)
        else if (popupType == 'renamebox') setShowRenameBox(false)
        else if (popupType == 'alertbox') setShowAlertBox(false)
        else if (popupType == 'aientitytitlebox') setShowAIEntityTitleBox(false)
        else if (popupType == 'waitingbox') setShowWaitingBox(false)
        else if (popupType == 'askforreview') setShowAskForReviewBox(false)
        setWaiting(false);
        // Remove body class (remove-scroll) when any reference popup is closed.
        removeBodyScroll(false);
        if(typeof callback == 'function') callback();
    }
    //For popup components
    const status = (type) => {
        if (type == 'msgbox' && popupType == 'msgbox') return showMsgBox
        else if (type == 'confirmbox' && popupType == 'confirmbox') return showConfirmBox
        else if (type == 'sharebox' && popupType == 'sharebox') return showShareBox
        else if (type == 'downloadbox' && popupType == 'downloadbox') return showDownloadBox
        else if (type == 'rearrangebox' && popupType == 'rearrangebox') return showRearrangeBox
        else if (type == 'duplicatebox' && popupType == 'duplicatebox') return showDuplicateBox
        else if (type == 'renamebox' && popupType == 'renamebox') return showRenameBox
        else if (type == 'alertbox' && popupType == 'alertbox') return showAlertBox
        else if (type == 'aientitytitlebox' && popupType == 'aientitytitlebox') return showAIEntityTitleBox
        else if (type == 'waitingbox' && popupType == 'waitingbox') return showWaitingBox
        else if (type == 'askforreview' && popupType == 'askforreview') return showAskForReviewBox
    }
     //For components to show popup
    //config {[id]:{type, content}}
    const configurePopup = config => !Object.keys(boxes).length && setBoxes({...config});
    
    //For popup components
    const rightCallbackAction = (closepopup = true, params = false) => {
        rightCallback?.e && rightCallback.e(params);
        closepopup && close();
    }
     //For popup components
    const leftCallbackAction = (closepopup = true) => {
        leftCallback?.e &&  leftCallback.e();
        closepopup && close();
    }
    return (
        <PopupContext.Provider value={{ show, configurePopup, close, rightCallbackAction, leftCallbackAction, status, boxContent, data, waiting, setWaiting }}>
            {children}
        </PopupContext.Provider>)
}//
//export default ResumeContext;
export const usePopup = () => {
    const context = useContext(PopupContext);
    return context;
}
